import { INTERVAL_INPUT_MAX, INTERVAL_INPUT_MIN, INTERVAL_INPUT_STEP } from '../../constants';

export const TEST_ID = 'intervalConfigRow';

export const INPUT_MIN = INTERVAL_INPUT_MIN;

export const INPUT_MAX = INTERVAL_INPUT_MAX;

export const INPUT_STEP = INTERVAL_INPUT_STEP;
